import { useState } from 'react';
import { PennyCommandDrawer } from '../command/PennyCommandDrawer';
import { Sidebar } from './Sidebar';
import { MobileTopBar } from './MobileTopBar';
import { MobileBottomNav } from './MobileBottomNav';
import { UiStoreToastBridge } from './UiStoreToastBridge';

export interface AppShellProps {
  children: React.ReactNode;
  userName?: string;
  userRole?: string;
  onLogout?: () => void;
}

export function AppShell({ children, userName = 'User', userRole = 'owner', onLogout }: AppShellProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [commandOpen, setCommandOpen] = useState(false);

  return (
    <div className="flex h-full">
      {/* Grain overlay */}
      <div className="grain" aria-hidden="true" />

      {/* ── Desktop sidebar (lg+) ─────────────────────────────────────────── */}
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        userName={userName}
        userRole={userRole}
        onLogout={onLogout}
        onOpenCommand={() => setCommandOpen(true)}
      />

      {/* Sidebar backdrop on mobile when drawer open */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/60 backdrop-blur-sm lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* ── Main content area ─────────────────────────────────────────────── */}
      <div className="flex min-w-0 flex-1 flex-col">
        {/* Mobile top bar (hidden on desktop) */}
        <MobileTopBar
          userName={userName}
          onMenuToggle={() => setSidebarOpen(true)}
          onLogout={onLogout}
          onOpenCommand={() => setCommandOpen(true)}
        />

        {/* Page content */}
        <main className="flex-1 overflow-auto scrollbar-penny pb-20 lg:pb-0">
          {children}
        </main>

        {/* Mobile bottom nav (hidden on desktop) */}
        <MobileBottomNav onOpenCommand={() => setCommandOpen(true)} />
      </div>

      <PennyCommandDrawer open={commandOpen} onOpenChange={setCommandOpen} />
      <UiStoreToastBridge />
    </div>
  );
}
